import * as Constants from '../constants/purchase-location';

export const createPurchaseLocation = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_PURCHASE_LOCATION_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/transactions/purchase-locations/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_PURCHASE_LOCATION_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_PURCHASE_LOCATION_FAILED, payload: error });
        reject(error);
      });
  });

export const updatePurchaseLocation = ($http, ENV, purchaseLocationId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_PURCHASE_LOCATION_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/transactions/purchase-locations/${purchaseLocationId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_PURCHASE_LOCATION_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_PURCHASE_LOCATION_FAILED, payload: error });
        reject(error);
      });
  });

export const getPurchaseLocation = ($http, ENV, purchaseLocationId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_PURCHASE_LOCATION_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/transactions/purchase-locations/${purchaseLocationId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_PURCHASE_LOCATION_SUCCESS,
          payload: res.data['purchase-location'],
        });
        resolve(res.data['purchase-location']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_PURCHASE_LOCATION_FAILED, payload: error });
        reject(error);
      });
  });

export const disablePurchaseLocation = ($http, ENV, purchaseLocationId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.DISABLE_PURCHASE_LOCATION_REQUEST });

    $http({
      method: 'DELETE',
      url: ENV.apiEndpoint + `/2.0/transactions/purchase-locations/${purchaseLocationId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.DISABLE_PURCHASE_LOCATION_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.DISABLE_PURCHASE_LOCATION_FAILED, payload: error });
        reject(error);
      });
  });

export const setPurchaseLocation = (data) => (dispatch) =>
  dispatch({ type: Constants.SET_PURCHASE_LOCATION, payload: data });
